import { UserStatusEnum } from '@aorg/models/enums/access/UserStatusEnum';
import { UserTypeEnum } from '@aorg/models/enums/access/UserTypeEnum';
import {
  selectSessionAuth,
  selectSessionUser,
  useAppSelector,
} from '@aorg/store';
import { useEffect, type PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAmplitude from '../hooks/useAmplitude';
import { useHandleRedirectPage } from '../hooks/useHandleRedirectPage';

function AuthGuard({ children }: PropsWithChildren) {
  const isAuthenticated = useAppSelector(selectSessionAuth);
  const user = useAppSelector(selectSessionUser);
  const location = useLocation();
  const { pathname } = location;
  const { updateUserAnalytics } = useAmplitude();

  useHandleRedirectPage();

  useEffect(() => {
    if (!user) return;

    updateUserAnalytics(user);
  }, [user]);

  if (!isAuthenticated) {
    const targetPath = `${pathname}${location.search}`;
    if (targetPath && targetPath !== '/') {
      localStorage.setItem('redirectAfterLogin', targetPath);
    }
    return <Navigate to="/sign-in" />;
  }

  if (
    user?.status === UserStatusEnum.Pending &&
    !pathname.includes('/survey')
  ) {
    return <Navigate to="/pending" />;
  }

  if (
    user?.status === UserStatusEnum.Waiting &&
    user?.type === UserTypeEnum.Stakeholder
  ) {
    return <Navigate to="/waiting" />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

export default AuthGuard;
